// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"131":"af40b8b7c4c01185ee3c","781":"bdaaabd884036f5a6bf0"}[chunkId] + ".css";
};